import { CONDITIONS } from '../../common';

/* @deprecated */
export enum SEGMENT_VALUE_TYPE {
  NONE = 'none',
  MULTISELECT = 'multiselect',
  INPUT = 'input',
  LIST = 'list',
  DATE = 'date',
  DATE_INPUT = 'date+input',
  MULTISELECT_INPUT = 'multiselect+input',
  DATE_MULTISELECT_INPUT = 'date+multiselect+input',
}

export enum SEGMENT_INPUT_TYPE {
  NONE = 'none',
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  INPUT = 'input',
  DATE = 'date',
  RELATIVE_DATE = 'relative_date',
  NUMBER = 'number',
  SUBTAG = 'subtag',
  LIST = 'list',
  SOURCE = 'source',
}

export enum SEGMENT_BOOLEAN_JOIN {
  AND = 'and',
  OR = 'or',
}

export const FILTER_PATH_ROOT = 'root';

export enum SEGMENT_FILTER_TYPE {
  ATTRIBUTE = 'attribute',
  AUTO_EVENT = 'aevent',
  USER_TAG = 'user_tag',
  USER_EVENT = 'user_event',
  USER_EVENT_TAG = 'user_event_tag',
  USER_PRODUCT_TAG = 'user_product_tag',
  USER_PURCHASE_TAG = 'user_purchase_tag',
  UNSUPPORTED = 'unsupported',
  // ---- Usados en Funnels
  INAPP_IMPRESION = 'inapp_impressions',
  INAPP_CLICK = 'inapp_clicks',
  DEVICE_OS = 'device_os',
  FILTER_CAMPAIGN = 'filter_campaign',
}

export enum SEGMENT_FILTER_ATTRIBUTE {
  ACTIVE_FOR_PUSH = 'actives_for_push',
  ANDROID_MOBILE_SERVICES = 'android_mobile_services',
  COMMUNICATION = 'communication',
  DEVICE_APP_VERSION = 'device_app_version',
  DEVICE_APP_VERSION_ANDROID = 'device_app_version_android',
  DEVICE_APP_VERSION_IOS = 'device_app_version_ios',
  DEVICE_GEO_TYPE = 'device_geo_type',
  DEVICE_IDS = 'device_ids',
  DEVICE_MULTIPLE = 'device_multiple',
  DEVICE_NAME_ANDROID = 'device_name_android',
  DEVICE_NAME_IOS = 'device_name_ios',
  DEVICE_OS_VERSION_ANDROID = 'device_os_version_android',
  DEVICE_OS_VERSION_IOS = 'device_os_version_ios',
  DEVICE_SDK_ANDROID = 'device_sdk_android',
  DEVICE_SDK_IOS = 'device_sdk_ios',
  DEVICE_UDIDS = 'device_udids',
  NONE = 'none',
  OS = 'device_os',
  UNKNOWN = 'unknown',
  USER_AUDIENCE = 'user_audience',
  USER_CAMPAIGN = 'user_campaign',
  USER_CITY = 'user_city',
  USER_CONVERSION = 'user_conversion',
  USER_COUNTRY = 'user_country',
  USER_CUSTOMERS = 'user_customers',
  USER_EMAIL = 'user_email',
  USER_FIRST_LOGIN = 'user_first_login',
  USER_FIRST_PURCHASE = 'user_first_purchase',
  USER_INSTALL = 'user_install',
  USER_LAST_GEO = 'user_last_geo',
  USER_LAST_LOGIN = 'user_last_login',
  USER_LAST_PURCHASE = 'user_last_purchase',
  USER_LAST_SESSION = 'user_last_session',
  USER_PRODUCT_NAME = 'user_product_name',
  USER_PURCHASE_SPENT = 'user_purchase_spent',
  USER_PUSH_ACTIVE = 'user_push_active',
  USER_PUSH_OPEN = 'user_push_open',
  USER_PUSH_OVER_LIMIT = 'user_push_over_limit',
  USER_REGISTER = 'user_register',
  USER_RETARGETING = 'user_retargeting',
  USER_SOURCE = 'user_source',
  USER_STATE = 'user_state',
  JOURNEY = 'journey',
}

export enum SEGMENT_VIEW_KEY {
  EXPLORE_REPORT = 'exploreReport',
  PEOPLE_REPORT = 'peopleReport',
  JOURNEY_DESIGNER = 'journeyDesigner',
}

export const SEGMENT_CONDITION_INPUT = {
  [SEGMENT_INPUT_TYPE.NONE]: [
    CONDITIONS.IS_SET,
    CONDITIONS.IS_NOT_SET,
    CONDITIONS.WAS_MADE,
    CONDITIONS.WAS_NOT_MADE,
    CONDITIONS.IS_TRUE,
    CONDITIONS.IS_FALSE,
  ],
  [SEGMENT_INPUT_TYPE.NUMBER]: [
    CONDITIONS.EQUAL,
    CONDITIONS.NOT_EQUAL,
    CONDITIONS.MORE_THAN,
    CONDITIONS.LESS_THAN,
  ],
  [SEGMENT_INPUT_TYPE.DATE]: [CONDITIONS.WAS_ON, CONDITIONS.WAS_NOT_ON],
  [SEGMENT_INPUT_TYPE.RELATIVE_DATE]: [
    CONDITIONS.WAS_AGO,
    CONDITIONS.WAS_NOT_AGO,
    CONDITIONS.WAS_MORE_THAN,
    CONDITIONS.WAS_NOT_MORE_THAN,
    CONDITIONS.WAS_LESS_THAN,
    CONDITIONS.WAS_NOT_LESS_THAN,
    CONDITIONS.WILL_BE_IN,
    CONDITIONS.ANNIVERSARY_IS,
  ],
  [SEGMENT_INPUT_TYPE.MULTISELECT]: [
    CONDITIONS.EQUAL,
    CONDITIONS.NOT_EQUAL,
    CONDITIONS.CLICKED,
    CONDITIONS.NOT_CLICKED,
    CONDITIONS.ENGAGED,
  ],
  [SEGMENT_INPUT_TYPE.INPUT]: [CONDITIONS.CONTAINS],
  [SEGMENT_INPUT_TYPE.SELECT]: [CONDITIONS.GREATER_THAN, CONDITIONS.MINOR_THAN],
  [SEGMENT_INPUT_TYPE.SUBTAG]: [CONDITIONS.WITH_PROPERTY],
  [SEGMENT_INPUT_TYPE.SOURCE]: [CONDITIONS.ATTRIBUTED],
};
